import { Navigate, Route, Routes as RouterRoutes } from 'react-router-dom';

import BetaFeatureGuard from './guards/BetaFeatureGuard';
import DmsAdministratorGuard from './guards/DmsAdministratorGuard';
import DmsOperatorGuard from './guards/DmsOperatorGuard';
import AuditReportPage from '../components/AuditReportPage/AuditReportPage';
import ActionsWorkbench from '../components/ActionsWorkbench';
import AdminSettingsPage from '../components/AdminSettingsPage/AdminSettingsPage';
import { DashboardPage } from '../components/DashboardPage';
import IngestionObservabilityPage from '../components/IngestionObservabilityPage';
import LoginPage from '../components/LoginPage';
import MapViewPage from '../components/MapViewPage';
import { FEATURE_FLAGS } from '../config/featureFlags';
import NotFoundPage from '../components/NotFoundPage';
import NotificationsView from '../components/NotificationsView';
import ProtectedWrapper from './ProtectedWrapper';
import RTUDataDisplay from '../components/RTUDataDisplay/RTUDataDisplay';
import RTUList from '../components/RTUList/RTUList';
import RTUTreeList from '../components/RtuTreeList/RTUTreeList';
import React from 'react';

const Routes: React.FC = () => {
  return (
    <>
      <RouterRoutes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<ProtectedWrapper><DashboardPage /></ProtectedWrapper>} />
        <Route path="/dashboard" element={<ProtectedWrapper><DashboardPage /></ProtectedWrapper>} />
        {FEATURE_FLAGS.mapView && (
          <Route
            path="/mapview"
            element={
              <ProtectedWrapper>
                {FEATURE_FLAGS.mapViewRequiresBeta ? (
                  <BetaFeatureGuard>
                    <MapViewPage />
                  </BetaFeatureGuard>
                ) : (
                  <MapViewPage />
                )}
              </ProtectedWrapper>
            }
          />
        )}
        {FEATURE_FLAGS.ingestionObservability && (
          <Route
            path="/observability/ingestion"
            element={
              <ProtectedWrapper>
                <DmsOperatorGuard>
                  <IngestionObservabilityPage />
                </DmsOperatorGuard>
              </ProtectedWrapper>
            }
          />
        )}
        <Route path="/rtulist" element={<ProtectedWrapper><RTUList /></ProtectedWrapper>} />
        <Route path="/rtutreelist" element={<ProtectedWrapper><RTUTreeList /></ProtectedWrapper>} />
        <Route path="/rtupage/:rtuId" element={<ProtectedWrapper><RTUDataDisplay /></ProtectedWrapper>} />
        {FEATURE_FLAGS.actionsTracking ? (
          <>
            <Route path="/actions" element={<ProtectedWrapper><DmsOperatorGuard><ActionsWorkbench /></DmsOperatorGuard></ProtectedWrapper>} />
            {/* Keep the legacy URL, but use the canonical access-filtered actions view. */}
            <Route path="/audit/actions" element={<ProtectedWrapper><DmsOperatorGuard><ActionsWorkbench /></DmsOperatorGuard></ProtectedWrapper>} />
            <Route path="/audit/report" element={<ProtectedWrapper><DmsOperatorGuard><AuditReportPage /></DmsOperatorGuard></ProtectedWrapper>} />
          </>
        ) : null}
        <Route path="/admin/ping-settings" element={<ProtectedWrapper><Navigate to="/admin/settings/reachability/ping-templates" replace /></ProtectedWrapper>} />
        <Route path="/admin/settings" element={<ProtectedWrapper><DmsAdministratorGuard><AdminSettingsPage /></DmsAdministratorGuard></ProtectedWrapper>} />
        <Route path="/admin/settings/:section" element={<ProtectedWrapper><DmsAdministratorGuard><AdminSettingsPage /></DmsAdministratorGuard></ProtectedWrapper>} />
        <Route path="/admin/settings/:section/:page" element={<ProtectedWrapper><DmsAdministratorGuard><AdminSettingsPage /></DmsAdministratorGuard></ProtectedWrapper>} />
        {/* <Route path="/rtupage/:rtuId" element={<ProtectedWrapper><RTUPage /></ProtectedWrapper>} /> */}
        <Route path="/notifications" element={<ProtectedWrapper><NotificationsView /></ProtectedWrapper>} />
        <Route path="*" element={<NotFoundPage />} />
      </RouterRoutes>
    </>

  );
};

export default Routes;
